module.exports = __webpack_public_path__ + "static/img/p3.6c8d6ff5.png";